import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'scroll',
  },
  bidBadge: {
    display: 'flex',
    height: 55,
    justifyContent: 'space-between',
  },
  bidInfoText: {
    marginTop: 5,
    color: theme.palette.colors.darkBlueGray,
  },
  divider: {
    width: '100%',
    borderBottom: `1px solid ${theme.palette.colors.divider}`,
  },
  applyButton: {
    marginTop: 32,
    height: 48,
    width: '100%',
  },
  icon: {
    fill: theme.palette.colors.white,
  },
  notes: {
    marginTop: 32,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanTermsInfo/useStyles.js